import { render, staticRenderFns } from "./dropdown_create_label.vue?vue&type=template&id=44945b54&"
import script from "./dropdown_create_label.vue?vue&type=script&lang=js&"
export * from "./dropdown_create_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dropdown_create_label.vue"
export default component.exports